import './SelectProject.scss';

import React, { ChangeEvent, FC, useContext, useEffect } from 'react';
import { AppContext } from 'components/AppContext/AppContext';
import { Form } from 'react-bootstrap';
import { useLocation, useSearchParams } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SelectProjectProps { }

const SelectProject: FC<SelectProjectProps> = () => {
  const { projects, selectedProjectId, setSelectedProjectIdAsync, isProjectSelectable } =
    useContext(AppContext);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isNewProject = searchParams.get('new_project') === 'true';

  const onProjectChanged = async (event: ChangeEvent<HTMLSelectElement>) => {
    const newProjectId = parseInt(event.target.value, 10);
    if (!Number.isNaN(newProjectId)) {
      await setSelectedProjectIdAsync(newProjectId);
    } else {
      await setSelectedProjectIdAsync(undefined);
    }
  };

  useEffect(() => {
    const fetchData = async (projectId: number | undefined) => {
      await setSelectedProjectIdAsync(projectId);
    };

    if (!isProjectSelectable &&
      projects.length > 0 &&
      !selectedProjectId &&
      !isNewProject) {
      fetchData(projects[0].id);
    }

    if (projects.length > 0 && isProjectSelectable) {
      if (!selectedProjectId) {
        fetchData(projects[0].id);
      }
      const selectedProject = projects.find(p => p.id === selectedProjectId);
      if (!selectedProject) {
        fetchData(projects[0].id);
      }
    }
  }, [projects, selectedProjectId, isProjectSelectable, isNewProject]);

  if (location.pathname.includes('account') || location.pathname.includes('account/verify')) {
    return <div />;
  }

  if (!projects || projects.length === 0) {
    return (
      <Form className="project-selector">
        <Form.Label className="select-label">Loading projects...</Form.Label>
      </Form>
    );
  }

  if (!selectedProjectId) {
    return (<Form className="project-selector" />);
  }

  return (
    <Form className="project-selector">
      <Form.Label className="select-label visually-hidden" htmlFor="selectProject">
        Set Project:
      </Form.Label>
      <Form.Select
        id="selectProject"
        name="selectProject"
        className="select"
        onChange={onProjectChanged}
        value={selectedProjectId}
        disabled={!isProjectSelectable}
      >
        {projects.map((p) => (
          <option value={p.id} key={p.id}>
            {p.name}
          </option>
        ))}
      </Form.Select>
    </Form>
  );
};

export default SelectProject;
